import React from "react";
import styled from "styled-components";
import { Link, useNavigate } from "react-router-dom";

const FooterLinksStyle = styled.div`
  .links__wrapper {
    display: flex;
    flex-direction: column;
    gap: 9px;
    .footer__link {
      color: #fff;
      font-size: 12px;
      font-weight: 400;
      line-height: 18px;
      display: inline-flex;
      gap: 9px;
    }
  }
`;

const FooterLinks = ({ title, links, linksType }) => {
  const navigate = useNavigate();

  const handleCategoryClick = (link) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate(link);
  };

  return (
    <FooterLinksStyle>
      <h2 className="title">{title}</h2>
      <div className="links__wrapper">
        {links?.map((item) => (
          <div key={item?.id}>
            {linksType === "social" ? (
              <a href={item?.link} target="_blank" rel="noopener noreferrer" className="footer__link">
                {item?.icon}
                {item?.title}
              </a>
            ) : title === "Categories" ? (
              <button
                onClick={() => handleCategoryClick(item?.link)}
                className="footer__link"
                style={{
                  background: 'none',
                  border: 'none',
                  padding: 0,
                  cursor: 'pointer',
                  textAlign: 'left'
                }}
              >
                {item?.icon}
                {item?.title}
              </button>
            ) : (
              <Link to={item?.link} className="footer__link">
                {item?.icon}
                {item?.title}
              </Link>
            )}
          </div>
        ))}
      </div>
    </FooterLinksStyle>
  );
};

export default FooterLinks;
